import React, {useEffect, useState} from "react";
import {Card} from "antd";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import rehypePrism from "rehype-prism";
import ReactMarkdown from "react-markdown";

const {Meta} = Card;
const DoubleIncAnalysisCard = ({result}) => {
    // 结果
    const [output, setOutput] = useState('');

    useEffect(() => {
        // 匹配行内公式 \( ... \)
        const inlineMathRegex = /\\\((.*?)\\\)/g;
        // 匹配段落公式 \[ ... \]，支持跨行匹配
        const blockMathRegex = /\\\[\s*([\s\S]*?)\s*\\\]/g;

        // 替换行内公式为 $...$
        let output = result.replace(inlineMathRegex, (match, p1) => {
            return `$ ${p1} $`;  // 用$包裹行内公式
        });

        // 替换段落公式为 $$...$$
        output = output.replace(blockMathRegex, (match, p1) => {
            return `\n$$\n${p1}\n$$`;  // 用$$包裹段落公式
        });
        setOutput(output);
    }, [result]);

    return (
        <Card bordered={true} style={{width: '80%', display: result.length === 0 ? 'none' : 'block'}}>
            <ReactMarkdown remarkPlugins={[remarkGfm, remarkMath]} // 支持数学公式
                           rehypePlugins={[rehypeKatex, rehypePrism]}>
                {output}
            </ReactMarkdown>
        </Card>
    );
};

export default DoubleIncAnalysisCard;